var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React from 'react';
export var Tab = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, component = _a.component, title = _a.title, _b = _a.active, active = _b === void 0 ? false : _b, props = __rest(_a, ["className", "children", "component", "title", "active"]);
    var Component = component || 'button';
    return (React.createElement(Component, __assign({}, props, { className: clsx(className, 'relative py-2 px-3 box-border h-10', active ? 'text-neutral-8 border-b-2 border-primary' : 'border-b border-neutral-3 text-neutral-5'), ref: ref, children: title })));
});
